/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareNotification {
        alert(title: string, message: string, buttonText?: string) : void;
        error(message: string, options?: any) : void;
        apiError(response: any, alternateMessage?: string, options?: any) : void;
        toast(message: string, delay?: number) : void;
        fullToast(options : any) : ng.IPromise<{}>;
    }


    export class Notification implements IDealerwareNotification {
        public static $inject: string[] = [
            '$mdDialog',
            '$mdToast',
            '$dealerwareInternationalizationData'
        ];

        public labels: {};

        constructor(public $mdDialog: any, public $mdToast: any, public $dealerwareInternationalizationData: any) {
            this.getLabels('errorMessages');
        }

        public alert(title: string, message: string, options?: any, buttonText?: string, callback?: any) : void {
            this.$mdDialog.show(this.$mdDialog.alert(options)
                .clickOutsideToClose(true)
                .title(title)
                .htmlContent(message)
                .ariaLabel(title)
                .ok(buttonText || 'OK')
                .multiple(true)
            ).finally(callback);
        }

        public getLabels(module: string) : void {
            var _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                })
                .catch( function (res: any) {
                    this.alert('Error', res);
                });
        }

        public error(message: string, options?: any, callback?: any) : void {
            this.alert('Error', message, options, undefined, callback);
        }

        public apiError(response: any, alternateMessage?: string, options?: any, callback?: any) : void {
            var unknownLabel = this.labels ? this.labels.unknown : "Unknown Error";

            if (response.status !== 401) {
                var message = (response && response.message) ||
                              (response && response.data && response.data.message) ||
                              (response && response.data && response.data.error_message) ||
                              (response && response.statusText) || alternateMessage || unknownLabel;
                this.error(this.regularizeMessageText(message), options, callback);
            }
        }

        public toast(message: string, delay?: number) : void {
            return this.$mdToast.show(this.$mdToast.simple()
                .textContent(message)
                .hideDelay(delay || 1500)
            );
        }

        public fullToast(options: any) : ng.IPromise<{}> {
            return this.$mdToast.show(options);
        }

        // Though opinions vary somewhat, most human interface guidelines recommend that in
        // non-title, error, warning, or notification text, if the text is a complete sentence,
        // proper punctuation should be used.  Our API is very inconsistent with using the
        // trailing punctuation, but pretty much all of the error messages are complete sentences.
        //
        public regularizeMessageText(message: string) : string {
            return message
                .replace(/.$/, function (lastChar) {
                    if (lastChar === '!' || lastChar === '?' || lastChar === '.') {
                        return lastChar;
                    }

                    return lastChar + '.';
                })
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareNotification", Notification);
}
